import { makeStyles } from '@material-ui/styles'

const styles = makeStyles(() => ({
  button: {
    margin: 5,
  },
}))

export default styles
